module.exports.string = require('./string')
